<template>
  <div class="home">
    <div id="backgroundDiv" class="login-bg-image" style="background-image: none"></div>
    <div id="default-landing">
      <div data-se="landing-container-center" class="landing-container-center main-container">
        <div id="sonosLogo" class="standalone-sonos-logo">SONOS</div>
        <div id="sonosHeader" class="sonos-header" style="display: none;"></div>
        <div class="landing-content">
          <div>
            <h2 data-se="landing-head" class="landing-title landing-head" style="display: block;text-align: center;">{{ welcome_text }}</h2>
            <p style="display: block;text-align: center;">{{ message }}</p>
          </div>
          <div class="landing-content-inner"></div>
        </div>
        <div id="sonosFooter" class="sonos-footer" style="display: block;">
          <button class="landing-button" @click="redirect">{{ $t("button.continue") }}</button>
          <a v-on:click="onLogoutClicked" class="logout">{{ $t("button.logout") }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getEnvironment, envConfigs } from "@/auth";
import { OktaAuth } from "@okta/okta-auth-js";

export default {
  name: "Welcome",

  data() {
    return {
      welcome_text: this.$t("welcome.welcome"),
      message: "",
      claims: { preferred_username: "" },
    };
  },

  created: function() {
    this.env = getEnvironment();
    this.config = envConfigs[this.env];
    this.oktaAuth = new OktaAuth(this.config);
  },
  beforeMount: function() {
    var that = this;
    // parseFormUrl will parse the 'code' query param from the URL and make an async /token request
    this.oktaAuth.tokenManager
      .get("idToken")
      .then(idToken => {
        if (!idToken) {
          this.oktaAuth.token
            .parseFromUrl()
            .then(res => {
              that.tokens = res.tokens;
              that.oktaAuth.tokenManager.setTokens(res.tokens);
              var idTokenContent = that.oktaAuth.token.decode(that.tokens.idToken.idToken);
              // Vue gives us event based view updates. When an attribute defined in the 'data' object changes, the view will auto update
              // https://vuejs.org/v2/guide/reactivity.html
              that.message = idTokenContent.payload.preferred_username;
            })
            .catch(console.error);
        } else {
          that.message = idToken.claims.preferred_username;
          that.tokens = {
            idToken: idToken,
          };
        }
      })
      .catch(console.err);
  },

  mounted: function() {},

  methods: {
    onLogoutClicked: function() {
      this.oktaAuth.tokenManager.get("id_token");
      if (this.tokens.idToken.idToken) {
        var issuer = this.tokens.idToken.claims.iss;
        this.oktaAuth.tokenManager.clear();
        window.location.href = issuer + "/v1/logout?client_id=" + this.config.clientId + "&id_token_hint=" + this.tokens.idToken.idToken + "&post_logout_redirect_uri=" + this.config.logoutRedirect;
      }
    },
    getCookieValue: function(name) {
      return document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() || "";
    },
    redirect: function() {
      const continueLink = this.getCookieValue("appUrl");
      window.location.href = continueLink != "" ? continueLink : "https://www.sonos.com";
    },
  },
};
</script>

<style scroped>
#default-landing h2.landing-title {
  margin: 40px 0;
}

#default-landing .landing-button {
  margin-bottom: 28px;
}
</style>
